import {
  getNetReceiptRetailObject,
  getPhysicalInventoryAdjustmentObject,
  getRetailAdjustmentObject,
  getSalesMarginObject,
  getAdditionalInTransitObject
} from "./getSalesAndReceiptsObject";

const costByDeptSubTitle = ["net-receipt-detail", "additional-in-transit-cost"];
const retailByDeptSubTitle = [
  "retail-adjustments",
  "additional-in-transit-retail",
  "non-warehouse-transfer-retail",
  "additional-pos-detail-retail"
];

const formatSalesAndReceiptData = (data: any) => {
  const dataGroupedBySection = data?.map((parentItem: any) => {
    const tableDataObject: any = {
      title: { value: parentItem.title },
      isGrossMarginCollapsibleRow: true,
      subtitleColumnNo: 5,
      key: parentItem?.key
    };

    if (costByDeptSubTitle.includes(parentItem?.key)) {
      tableDataObject.rowSubtitle = "grossMarginReport.costByDept";
    }

    if (retailByDeptSubTitle.includes(parentItem?.key)) {
      tableDataObject.rowSubtitle = "grossMarginReport.retailByDept";
    }

    // eslint-disable-next-line array-callback-return
    const childRowData = parentItem?.items?.map((childItem: any) => {
      if (parentItem?.key === "sales-margin") {
        return getSalesMarginObject(parentItem, childItem);
      }

      if (
        parentItem?.key === "net-receipt-detail" ||
        parentItem?.key === "non-warehouse-transfer-retail"
      ) {
        return getNetReceiptRetailObject(parentItem, childItem);
      }

      if (parentItem?.key === "retail-adjustments") {
        return getRetailAdjustmentObject(parentItem, childItem);
      }

      if (parentItem?.key === "physical-inventory-details") {
        return getPhysicalInventoryAdjustmentObject(parentItem, childItem);
      }

      if (
        parentItem?.key === "additional-in-transit-cost" ||
        parentItem?.key === "additional-in-transit-retail" ||
        parentItem?.key === "additional-pos-detail-retail"
      ) {
        return getAdditionalInTransitObject(parentItem, childItem);
      }
    });

    tableDataObject.childRowData = childRowData;

    return tableDataObject;
  });

  return dataGroupedBySection;
};

export default formatSalesAndReceiptData;
